import axios from 'axios';
import { getAccessToken } from 'extensions/userInfoExtension';
import config from "../config.json";

export const PaymentMethods = {
    "iDEAL" : "iDEAL",
    "ApplePay" : "ApplePay",
    "GooglePay" : "GooglePay"
};

export const createSubscription = async (paymentMethod) => {
  let configuration = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/prod/user/subscription',
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    },
    data: {
      "paymentMethod": paymentMethod,
      "redirectUrl": `${config.portalDomain}`
    }
  }

  return await axios.request(configuration)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
}

export const getSubscription = async () => {
  let configuration = {
    method: 'get',
    maxBodyLength: Infinity,
    url: '/prod/user/subscription',
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    }
  }

  return await axios.request(configuration)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
}

export const cancelSubscription = async (subscriptionId) => {
  let configuration = {
    method: 'delete',
    maxBodyLength: Infinity,
    url: `/prod/user/subscription/${subscriptionId}`,
    headers: {
      'accept': '*/*',
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${getAccessToken()}`
    }
  }

  return await axios.request(configuration)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
}